const extractInnerText = (labelContent) => labelContent.split('\n').join('').trim();


/*
This function is used when a radio component is mounted inside grapesJs canvas. It checks if there are radio components near it and
if there are then we assign the same annotation attributes to the label component inside the radio component.
*/
function assignAnnotation(component, type) {
  const parent = component.parent();

  let found = false;

  parent.attributes.components.models.forEach((insideComp) => {
    if (
      component !== insideComp &&
      insideComp.attributes.attributes.wablitype !== undefined &&
      insideComp.attributes.attributes.wablitype === type &&
      found === false
    ) {
      found = true;

      let annotationname = '';

      insideComp.attributes.components.models.forEach((insideComp2) => {
        if (insideComp2.attributes.tagName === 'label') {
          if (insideComp2.attributes.attributes.annotationname !== undefined) {
            annotationname = insideComp2.attributes.attributes.annotationname;
          } else {
            annotationname = -1;
          }
        }
      });

      component.attributes.components.models.forEach((insideComp3) => {
        if (insideComp3.attributes.tagName === 'label') {
          if (annotationname !== -1) {
            insideComp3.addAttributes({ annotationname });

            let labelContent = '';
            try {
              labelContent = insideComp3.view.$el[0].innerText;
            } catch (e) {
              labelContent = '';
            }

            const realLabelContent = extractInnerText(labelContent);

            insideComp3.addAttributes({ annotationvalue: realLabelContent });
          
          }
        }
      });
    }
  });
}

const editRadioComps = (editor) => {

    editor.on("component:mount", (component) => {
              
        if(component.attributes.attributes.wablitype !== undefined){
          if(component.attributes.attributes.wablitype === 'radios'){
            const radioCid = component.parent().cid
          
            component.attributes.components.models.forEach( (insideModel) => {
              if(insideModel.attributes.tagName === 'input'){
                insideModel.addAttributes({name: `flexRadioDefault${radioCid}`})
              }        
            })
            assignAnnotation(component, 'radios');
          }
          else if(component.attributes.attributes.wablitype === 'inline-radios'){
            const inlineRadiosCid = component.parent().cid
            component.attributes.components.models.forEach( (insideModel) => {
              if(insideModel.attributes.tagName === 'input'){
                insideModel.addAttributes({name: `flexRadioInlineDefault${inlineRadiosCid}`})
              }        
            })
          }
          else if(component.attributes.attributes.wablitype === 'checkboxes'){
            assignAnnotation(component, 'checkboxes');
          }
          
        }
    })

}





export default editRadioComps
